export const STYLE_COVER_LONGEST_SIDE = 2048
export const STYLE_COVER_OUTPUT_QUALITY = 0.9
